import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class BioGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bio: props.initialValue || ''
    };
  }

  handleBioChange = event => {
    this.setState({ bio: event.target.value });
  }

  submit = () => {
    const { bio } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ bio })
    }
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13 && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      this.submit();
    }
  }

  // render
  render() {
    const { t, updating, wizardMode } = this.props;
    const { bio } = this.state;
    return (
      <div>
        <h2>{t('Bio')}</h2>
        <p>{t('OnYourProfile')}</p>
        <label className='br-field'>
          <span className='br-field__label'>{t('Bio')}</span>
          <textarea className='br-field__input' placeholder={t('BioPlaceholder')}
            value={bio} onChange={this.handleBioChange}
            onKeyDown={this.handleKeyDown} />
        </label>
        <Button style={{marginTop: '1em'}} disabled={updating}
          aria-busy={updating} onClick={this.submit}>
          {wizardMode ? (bio.length === 0 ? t('Skip') : t('Next')) : t('Save')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(BioGetter)
